<template>
    <div>
        <router-view></router-view>
        <c-alert></c-alert>
        <c-confirm></c-confirm>
        <c-loading></c-loading>
        <c-toast></c-toast>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>

import $ from 'jquery';
import './assets/global/scripts/bootstrap';
import './assets/global/scripts/ajaxfileupload';

import cAlert from './components/alert';
import cConfirm from './components/confirm';
import cLoading from './components/loading';
import cToast from './components/toast';
import cHelperTip from './components/ar-tooltip-helper';

export default {
    mounted: function(){
        //AppJS.init();
        //LayoutJS.init();
        let self = this;

        $(document).ajaxComplete(function(evt, res, settings){

          let ret = res && res.responseJSON;

          if(ret && ret.code === 401) {
            self.$router.push({
              name: 'login'
            });
          }
        });
    },
    components: {
      cAlert,
      cConfirm,
      cLoading,
      cToast,
      cHelperTip
    }
}
</script>

<style>


@import './assets/global/plugins/font-awesome/css/font-awesome.css';
@import './assets/global/plugins/simple-line-icons/simple-line-icons.css';
@import './assets/global/plugins/bootstrap/css/bootstrap.css';
@import './assets/global/plugins/uniform/css/uniform.default.css';
@import './assets/global/plugins/bootstrap-switch/css/bootstrap-switch.css';

@import './assets/global/css/components.css';
@import './assets/global/css/plugins.css';
@import './assets/layouts/layout/css/layout.css';
@import './assets/layouts/layout/css/themes/light2.min.css';
@import './assets/layouts/layout/css/custom.css';
@import './assets/global/plugins/fancybox/source/jquery.fancybox.css';

.modal{
  display: block;
}
</style>
